const data = [
  {
    image: require("../assets/Images/Person1.png"),
    title: "John Doe",
    rating: "4.0",
    isVerified: true,
    description:
      "body2. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos blanditiis tenetur unde suscipit, quam beatae rerum inventore consectetur, neque doloribus, cupiditate numquam dignissimos laborum fugiat deleniti? Eum quasi quidem quibusdam.",
  },
  {
    image: require("../assets/Images/Person2.png"),
    title: "Albert Einstein",
    rating: "4.2",
    isVerified: true,
    description:
      "body2. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos blanditiis tenetur unde suscipit, quam beatae rerum inventore consectetur, neque doloribus, cupiditate numquam dignissimos laborum fugiat deleniti? Eum quasi quidem quibusdam.",
  },
  {
    image: require("../assets/Images/Person3.png"),
    title: "Ammanat Bhai",
    rating: "4.5",
    isVerified: true,
    description:
      "body2. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos blanditiis tenetur unde suscipit, quam beatae rerum inventore consectetur, neque doloribus, cupiditate numquam dignissimos laborum fugiat deleniti? Eum quasi quidem quibusdam.",
  },
  {
    image: require("../assets/Images/Person4.png"),
    title: "Tayyab Manzoor",
    rating: "5.0",
    isVerified: true,
    description:
      "body2. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos blanditiis tenetur unde suscipit, quam beatae rerum inventore consectetur, neque doloribus, cupiditate numquam dignissimos laborum fugiat deleniti? Eum quasi quidem quibusdam.",
  },
];

export default data;
